import * as Yup from 'yup';
import 'utils/phoneValidator';
import { schema } from 'views/distributor/building/newWarranty';

export default (intl, country) =>
  Yup.object().shape({
    /*customer: Yup.object().shape({
      firstname: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar un nombre' }),
      ),
      lastname: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar un apellido' }),
      ),
      email: Yup.string()
        .email(intl.formatMessage({ id: 'Debe ingresar un email válido' }))
        .required(intl.formatMessage({ id: 'Debe ingresar un email válido' })),
      cellphone: Yup.string()
        .phone(
          intl.formatMessage({ id: 'Debe ingresar un teléfono válido' }),
          country,
        )
        .required(
          intl.formatMessage({ id: 'Debe ingresar un teléfono válido' }),
        ),
      phone: Yup.string().phone(
        intl.formatMessage({ id: 'Debe ingresar un teléfono válido' }),
        country,
      ),
    }),*/
    data: Yup.object().shape({
      //Project
      /*name: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar un nombre' }),
      ),
      type: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
        .typeError(intl.formatMessage({ id: 'Debe seleccionar un tipo' })),
      address: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar una calle' }),
      ),
      number: Yup.number()
        .required(intl.formatMessage({ id: 'Debe ingresar un número' }))
        .typeError(intl.formatMessage({ id: 'Debe ingresar un número' })),
      postalCode: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar un código postal' }),
      ),
      state: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar una provincia' }))
        .typeError(
          intl.formatMessage({ id: 'Debe seleccionar una provincia' }),
        ),*/
      // city: Yup.string()
      //   .required(intl.formatMessage({ id: 'Debe seleccionar una ciudad' }))
      //   .typeError(intl.formatMessage({ id: 'Debe seleccionar una ciudad' })),

      //glass
      /*glass: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
        .typeError(intl.formatMessage({ id: 'Debe seleccionar un tipo' })),
      Checklist: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar una opción' }))
        .typeError(intl.formatMessage({ id: 'Debe seleccionar una opción' })),
*/
      // status
      status: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
        .typeError(intl.formatMessage({ id: 'Debe seleccionar un tipo' })),
      finish: Yup.object().test(
        'hasFinishDate',
        intl.formatMessage({ id: 'Debe ingresar una fecha de cierre' }),
        (value) => Boolean(value.month && value.year),
      ),
      progress: Yup.string().test(
        'isDone',
        'Estado y avance de proyecto no coinciden',
        function (progress) {
          if (progress === '100% Cierre / Ganada') {
            if (this.parent.status !== 'Ganada') {
              return false;
            } else {
              return true;
            }
          }

          if (progress !== '100% Cierre / Ganada') {
            if (this.parent.status === 'Ganada') {
              return false;
            } else {
              return true;
            }
          }
        },
      ),
      //installer
      employees: Yup.array().of(
        Yup.object().shape({
          id: Yup.string()
            .typeError(
              intl.formatMessage({ id: 'Debe ingresar un instalador' }),
            )
            .required(
              intl.formatMessage({ id: 'Debe ingresar un instalador' }),
            ),
        }),
      ),
      // sheets
      applications: Yup.array().of(
        Yup.object().shape({
          substrate: Yup.string()
            .typeError(
              intl.formatMessage({ id: 'Debe seleccionar una opción' }),
            )
            .required(
              intl.formatMessage({ id: 'Debe seleccionar una opción' }),
            ),
          family: Yup.string()
            .required(intl.formatMessage({ id: 'Debe seleccionar una opción' }))
            .typeError(
              intl.formatMessage({ id: 'Debe seleccionar una opción' }),
            ),

          need: Yup.string()
            .typeError(
              intl.formatMessage({ id: 'Debe seleccionar una opción' }),
            )
            .required(
              intl.formatMessage({ id: 'Debe seleccionar una opción' }),
            ),
          film: Yup.string()
            .required(intl.formatMessage({ id: 'Debe seleccionar una opción' }))
            .typeError(
              intl.formatMessage({ id: 'Debe seleccionar una opción' }),
            ),
          meters: Yup.number()
            .typeError(intl.formatMessage({ id: 'Debe ingresar un número' }))
            .required(intl.formatMessage({ id: 'Debe ingresar un número' })),
          run: Yup.mixed()
            .typeError(intl.formatMessage({ id: 'Debe ingresar un run' }))
            .required(intl.formatMessage({ id: 'Debe ingresar un run' })),
          distributor: Yup.object().shape({
            id: Yup.mixed().when('$data.status', (data, schema) => {
              if (data === 'Ganada') {
                return schema.required(
                  intl.formatMessage({
                    id: 'Debe seleccionar un distribuidor',
                  }),
                );
              }
              return schema;
            }),
          }),
        }),
      ),
    }),
  });
